(function(document, window, $) {
    'use strict';

    var Site = window.Site;

    $(document).ready(function($) {
        Site.run();

        if (! $('.toppins.site-pins').length) return;


        var $target = $('.toppins.site-pins').first();
        var pinsurl = $target.data('url');

        $(document).on('click','[data-type="pinit"]',function(e){
            e.preventDefault();
            var id = $(this).data('id');
            var mode = $(this).data('mode');
            var model = $(this).data('model');
            var l = Ladda.create(this);
            l.start();

            $.post(pinsurl, {'mode': mode, 'id':id,'model':model})
                .done(function (data) {

                    if (data.html !=undefined) {
                        $('.site-pins-items').html(data.html);
                        countPins();
                    }
                })
                .always(function(){
                    l.stop();
                })
        });


        $('#toppinsbutton').on('show.bs.dropdown', function (e) {
           resetHeight();

        });

        function resetHeight()
        {
            $('.toppins.site-pins .scrollable-container').css('height','');
        }

        function postPin(id, mode, model, button) {

            var l = Ladda.create(button);
            l.start();

            $.post(pinsurl, {'mode': mode, 'id':id,'model':model})
                .done(function (data) {

                    if (data.html !=undefined) {
                        $('.site-pins-items').html(data.html);
                        countPins();
                    }
                })
                .always(function(){
                    l.stop();
                })
        }

        function deletePin(id)
        {
            $.post(pinsurl, {'id':id, '_method': 'delete'})
                .done(function (data) {
                    //if (data.html !=undefined) {
                    //    $('.site-pins-items').html(data.html);
                    //    countPins();
                    //}
                })
        }

        function countPins()
        {
            var count = $('.site-pins-items a').length;
            if (count){
                $('.toppins.site-pins .badge').removeClass('hidden').text(count);
                $('.site-pins-menu').removeClass('hidden');
            }else{
                $('.toppins.site-pins .badge').addClass('hidden').text(count);
                $('.site-pins-menu').addClass('hidden');
            }
           // console.log('counting');
            resetHeight();
            var $scroll= $('.toppins.site-pins .scrollable');
            if ($scroll!=undefined) $scroll.first().asScrollable('update');

        }

        $('.toppins').on('click', '.site-menu-close', function(e){
            e.stopPropagation();
            $(this).closest('.list-group-item').remove();
            deletePin($(this).data('id'));
            countPins();
        });

        $('.toppins').on('click', '.btn-delete-pins', function(e){
            e.stopPropagation();
            $('.site-pins-items').html('');
            deletePin(0);
            countPins();
            resetHeight();
        });


        countPins();

    });


})(document, window, jQuery);